export default{
    portalUrl: "https://dev.promineo-portal.promineo.no/api/",
    portalReadTokenUrl: "https://dev.promineo-portal.promineo.no/api/azureadtoken"

}